import React, { useState } from 'react';

const AkbarTravelsSupplierHighlight = () => {
  const [activeTab, setActiveTab] = useState('about');
  const [billingCycle, setBillingCycle] = useState(1); // 1 = Monthly, 2 = Annually

  // Company Information - Zotrai (YOUR COMPANY)
  const companyInfo = {
    name: "Zotrai",
    themeColor: "#FF7F00",
    description: "Your trusted B2B travel technology partner",
    founded: "2020",
    headquarters: "India",
    agents: "10,000+",
    suppliers: "50+",
    countries: "100+",
    uptime: "99.9%",
    apiCalls: "100M+",
    team: "100+",
    email: "support@zotrai.com",
    phone: "+91-7207642485"
  };

   // Why Suppliers Choose Zotrai - REAL DATA
  const whyZotraiData = {
    benefits: [
        {
        id: 1,
        title: "Single API Integration, Multiple Connections",
        description: "Connect once with Zotrai and get instant access to all our partner suppliers - no multiple integrations needed",
        icon: "ri-plug-line",
        stat: "1",
        statLabel: "Integration"
      },
     {
  id: 2,
  title: "Launch B2B, B2C & Corporate Portals",
  description: "Fully customizable multi-agent, direct-sell, and corporate booking platforms under your brand",
  icon: "ri-window-line",
  stat: "All-in-One",
  statLabel: "Portal Suite"
},
    
      {
  id: 3,
  title: "Save 95% on Integration Costs",
  description: "No setup fees, no integration charges.",
icon: "ri-coins-line",

  stat: "95%",
  statLabel: "Cost Savings"
},
      {
        id: 4,
        title: "Real-time Analytics Dashboard",
        description: "Track your inventory performance, booking patterns, and agent behavior with detailed analytics",
        icon: "ri-bar-chart-2-line",
        stat: "24/7",
        statLabel: "Monitoring"
      },
      {
        id: 5,
        title: "99.9% Uptime Guarantee",
        description: "Enterprise-grade infrastructure with redundant systems ensuring your APIs are always available",
        icon: "ri-shield-check-line",
        stat: "99.9%",
        statLabel: "Uptime"
      },
      {
        id: 6,
        title: "Dedicated Account Manager",
        description: "Every supplier gets a dedicated technical account manager for seamless integration and support",
        icon: "ri-customer-service-line",
        stat: "24/7",
        statLabel: "Support"
      }
    ],
    process: [
      {
        step: 1,
        title: "Add Your API Credentials",
        description: "Just Login, paste your API keys, and we handle the rest – zero development effort"
      },
       {
        step: 2,
        title: "Select & Customize Template",
        description: "Pick from our library of 100+ responsive templates and match your brand identity"
      },
      {
        step: 3,
        title: "Go Live Instantly",
        description: "Deploy to production in one click and start accepting real bookings"
      }
    ]
  };
  // SEO-friendly structured data for Akbar Travels
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Akbar Travels",
    "description": "Integrated travel solutions provider specializing in hotel accommodations and holiday packages across India and Middle East",
    "url": "https://www.akbartravels.com",
    "areaServed": "Worldwide",
    "serviceType": ["Flight Booking", "Hotel Booking", "Holiday Packages", "Umrah Packages", "Visa Services"],
    "foundingDate": "1979",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Kerala",
      "addressCountry": "India"
    }
  };

  // Akbar Travels specific data
  const akbarData = {
    name: "Akbar Travels",
    description: "Integrated travel solutions provider specializing in hotel accommodations and holiday packages across India and Middle East. Trusted name in travel since 1979 with a global presence.",
    longDescription: "Akbar Travels is one of India's most trusted travel brands, established in 1979. With over four decades of experience, they have grown into a comprehensive travel solutions provider offering flights, hotels, holiday packages, Umrah packages, and visa services. Their extensive network spans across India, Middle East, USA, UK, and other key global destinations. Known for their personalized service and deep understanding of the Indian traveler's needs, Akbar Travels has become the preferred partner for thousands of travel agents worldwide.",
    founded: "1979",
    headquarters: "Kerala, India",
    employees: "2000+",
    branches: "150+",
    countries: "50+",
    hotels: "300K+",
    airlines: "150+",
    holidayPackages: "5000+",
    umrahPackages: "Specialized",
    apiCalls: "50M+",
    agents: "10,000+",
    themeColor: "#00A859", // Akbar Travels green color
    website: "https://www.akbartravels.com",
    apiType: "RESTful API",
    integrationType: "Direct API Integration",
    support: "24/7 Multi-lingual Support"
  };

  // Key features of Akbar Travels
  const features = [
    {
      icon: "🏨",
      title: "300K+ Hotel Properties",
      description: "Extensive hotel inventory across India, Middle East, and global destinations"
    },
    {
      icon: "✈️",
      title: "150+ Airlines",
      description: "Comprehensive flight inventory including domestic and international carriers"
    },
    {
      icon: "🕋",
      title: "Specialized Umrah Packages",
      description: "Complete Umrah travel solutions with accommodations in Makkah and Madinah"
    },
    {
      icon: "🎯",
      title: "Holiday Packages",
      description: "Curated holiday packages for popular destinations worldwide"
    }
  ];

  // Services offered by Akbar Travels
  const services = [
    {
      id: 1,
      title: "Flight Booking API",
      description: "Access to 150+ airlines with real-time pricing, availability, and instant confirmation.",
      features: [
        "Domestic & International flights",
        "Real-time fare updates",
        "PNR generation",
        "Multi-currency support"
      ],
      icon: "✈️"
    },
    {
      id: 2,
      title: "Hotel Booking API",
      description: "300,000+ hotel properties with detailed information, images, and instant booking.",
      features: [
        "Indian hotels specialty",
        "Middle East properties",
        "Budget to luxury options",
        "Cancellation policies"
      ],
      icon: "🏨"
    },
    {
      id: 3,
      title: "Umrah Packages",
      description: "Specialized Umrah travel solutions with complete package options.",
      features: [
        "Makkah & Madinah hotels",
        "Visa processing",
        "Transportation",
        "Guided assistance"
      ],
      icon: "🕋"
    },
    {
      id: 4,
      title: "Holiday Packages",
      description: "Curated holiday packages for popular destinations with dynamic pricing.",
      features: [
        "Domestic tour packages",
        "International holidays",
        "Custom itineraries",
        "Group packages"
      ],
      icon: "🌴"
    },
    {
      id: 5,
      title: "Visa Services",
      description: "Comprehensive visa processing services for multiple countries.",
      features: [
        "Document checking",
        "Application tracking",
        "Multiple country support",
        "Expert assistance"
      ],
      icon: "📋"
    },
    {
      id: 6,
      title: "Car Rentals",
      description: "Car rental services across major cities in India and Middle East.",
      features: [
        "Multiple vehicle types",
        "Airport transfers",
        "Hourly/Daily rentals",
        "Chauffeur options"
      ],
      icon: "🚗"
    }
  ];

  // Technology highlights
  const technology = [
    {
      title: "RESTful APIs",
      description: "Modern RESTful API architecture for seamless integration"
    },
    {
      title: "Real-time Inventory",
      description: "Live availability and pricing from all suppliers"
    },
    {
      title: "Multi-lingual Support",
      description: "APIs supporting multiple languages for global operations"
    },
    {
      title: "High Availability",
      description: "99.9% uptime with redundant infrastructure"
    },
    {
      title: "Secure Transactions",
      description: "PCI compliant with encrypted data transmission"
    },
    {
      title: "Scalable Architecture",
      description: "Handles peak season traffic without performance degradation"
    }
  ];

  // Integration process
  const integrationProcess = [
    {
      step: 1,
      title: "API Credentials",
      description: "Receive API credentials and comprehensive documentation"
    },
    {
      step: 2,
      title: "Sandbox Testing",
      description: "Test integration in Akbar Travels staging environment"
    },
    {
      step: 3,
      title: "Go Live",
      description: "Deploy to production with 24/7 technical support"
    }
  ];

  // Why choose Akbar Travels
  const whyChoose = [
    "Trusted brand since 1979 with 40+ years of experience",
    "Specialized expertise in Indian and Middle East travel",
    "Comprehensive Umrah travel solutions",
    "Extensive network of 150+ branches globally",
    "Multi-lingual customer support",
    "Direct contracts with hotels in India and Middle East"
  ];

  // Supplier logos array with navigation paths
  const suppliers = [
    { 
      id: 1, 
      name: "Tripjack", 
      logo: "/assets/images/suppliers/tripjack.png",
      path: "/supplier/trip-jack"
    },
    { 
      id: 2, 
      name: "TBO", 
      logo: "/assets/images/suppliers/tbo.png",
      path: "/supplier/tbo"
    },
    { 
      id: 3, 
      name: "Akbar Travels", 
      logo: "/assets/images/suppliers/akbar.png",
      path: "/supplier/akbar-travels"
    },
    { 
      id: 4, 
      name: "RezLive", 
      logo: "/assets/images/suppliers/rezlive.png",
      path: "/supplier/rezlive"
    },
    { 
      id: 5, 
      name: "GRN Connect", 
      logo: "/assets/images/suppliers/grn.png",
      path: "/supplier/grn-connect"
    },
    { 
      id: 6, 
      name: "Riya Travel", 
      logo: "/assets/images/suppliers/riya.png",
      path: "/supplier/riya-travel"
    },
    { 
      id: 7, 
      name: "Viator", 
      logo: "/assets/images/suppliers/viator.png",
      path: "/supplier/viator"
    },
    { 
      id: 8, 
      name: "Air iQ", 
      logo: "/assets/images/suppliers/airiq.png",
      path: "/supplier/air-iq"
    }
  ];

  // Pricing plans data
  const plans = [
    {
      id: 1,
      name: "Starter",
      description: "🚀 All-in-one powerful plan with complete access to every feature.",
      monthly: 2999,
      annually: 29999,
      popular: true,
      emoji: "🚀",
      features: [
        "Search, compare, and book flights from top global suppliers in one place",
        "Access and connect with 1,000+ verified global DMCs",
        "Smart accounting suite with ledgers, invoices, supplier settlements, and corporate payments",
        "Capture leads directly from social media and run promotions from a single dashboard",
        "Generate professional itineraries in minutes using AI",
        "AI-powered visa processing and document management system",
        "One unified platform for Flights, Hotels, Visas, Cars, Sightseeing, and more",
        "Integrated and secure payment gateway",
        "Plug in and manage your own supplier APIs seamlessly",
        "AI-based WhatsApp automation for leads, follow-ups, and customer support",
        "Unlimited email marketing and promotional campaigns",
        "Advanced reports and analytics for sales, revenue, and performance tracking",
      ],
      addons: [
        "Launch your own B2C booking website for customers in minutes – just INR 999",
        "Launch a full-featured B2C travel portal with flights, hotels, and packages using your preferred suppliers – INR 1,999",
        "Launch a B2B travel portal for your agent network with flights, hotels, and packages – INR 1,999",
        "Launch a B2E corporate travel portal for your business clients with flights, hotels, and packages – INR 1,999",
      ],
    },
  ];

  const getAccentColor = (planName) => {
    if (planName === "Starter") return "#10B981";
    if (planName === "Pro") return "#3B82F6";
    return "#8B5CF6";
  };

  const handleEmailClick = () => {
    window.location.href = `mailto:${companyInfo.email}`;
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${companyInfo.phone.replace(/[^0-9+]/g, '')}`;
  };

  const handleSupplierClick = (path) => {
    window.location.href = path;
  };

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Akbar Travels - Trusted Travel Partner Since 1979 | Zotrai</title>
        <meta name="description" content="Akbar Travels is India's most trusted travel brand offering flights, hotels, holiday packages, Umrah packages, and visa services through Zotrai integration." />
        <meta name="keywords" content="Akbar Travels supplier, Indian travel agency, Umrah packages, holiday packages, visa services, hotel booking India" />
        <link rel="canonical" href="https://yourcompany.com/supplier/akbar-travels" />
        
        {/* Open Graph tags */}
        <meta property="og:title" content="Akbar Travels - Trusted Travel Partner Since 1979" />
        <meta property="og:description" content="Connect with Akbar Travels' extensive network of 300K+ hotels and 150+ airlines through Zotrai's single API integration." />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      {/* Main Content with akbar- prefix */}
      <div className="akbar-supplier-container">
        {/* Header Section - Akbar Travels Hero */}
        <header className="akbar-header">
          <div className="akbar-container">
            <h1 className="akbar-title">
              <span className="akbar-highlight" style={{ color: akbarData.themeColor }}>Akbar Travels</span>
              <br />
              Trusted Travel Partner Since 1979
            </h1>
            <p className="akbar-subtitle">
              {akbarData.description}
            </p>
          </div>
        </header>

        {/* Tabs Navigation - Same as Tripjack */}
        <div className="akbar-tabs-container">
          <div className="akbar-container">
            <div className="akbar-tabs">
              <button 
                className={`akbar-tab ${activeTab === 'about' ? 'akbar-tab-active' : ''}`}
                onClick={() => setActiveTab('about')}
              >
                About
              </button>
              <button 
                className={`akbar-tab ${activeTab === 'services' ? 'akbar-tab-active' : ''}`}
                onClick={() => setActiveTab('services')}
              >
                Services
              </button>
              <button 
                className={`akbar-tab ${activeTab === 'technology' ? 'akbar-tab-active' : ''}`}
                onClick={() => setActiveTab('technology')}
              >
                Technology
              </button>
              <button 
                className={`akbar-tab ${activeTab === 'whyzotrai' ? 'akbar-tab-active' : ''}`}
                onClick={() => setActiveTab('whyzotrai')}
              >
                Why Zotrai <span className="akbar-tab-badge">For Suppliers</span>
              </button>
              <button 
                className={`akbar-tab ${activeTab === 'suppliers' ? 'akbar-tab-active' : ''}`}
                onClick={() => setActiveTab('suppliers')}
              >
                Suppliers
              </button>
              <button 
                className={`akbar-tab ${activeTab === 'pricing' ? 'akbar-tab-active' : ''}`}
                onClick={() => setActiveTab('pricing')}
              >
                Pricing
              </button>
            </div>
          </div>
        </div>

        {/* Tab Content */}
        <div className="akbar-tab-content">
          {activeTab === 'about' && (
            <section className="akbar-about">
              <div className="akbar-container">
                <div className="akbar-grid">
                  <div className="akbar-about-content">
                    <h2 className="akbar-section-title">About <span className="akbar-accent" style={{ color: akbarData.themeColor }}>Akbar Travels</span></h2>
                    <p className="akbar-text">
                      {akbarData.longDescription}
                    </p>
                    
                    <div className="akbar-features">
                      {features.map((feature, index) => (
                        <div key={index} className="akbar-feature">
                          <span className="akbar-feature-icon">{feature.icon}</span>
                          <div>
                            <h4>{feature.title}</h4>
                            <p>{feature.description}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className="akbar-card">
                    <h3 className="akbar-card-title">Akbar Travels at a Glance</h3>
                    <ul className="akbar-list">
                      <li className="akbar-list-item">
                        <span className="akbar-check" style={{ color: akbarData.themeColor }}>✓</span>
                        Established 1979 • 40+ Years of Trust
                      </li>
                      <li className="akbar-list-item">
                        <span className="akbar-check" style={{ color: akbarData.themeColor }}>✓</span>
                        300K+ Hotel Properties
                      </li>
                      <li className="akbar-list-item">
                        <span className="akbar-check" style={{ color: akbarData.themeColor }}>✓</span>
                        150+ Airline Connections
                      </li>
                      <li className="akbar-list-item">
                        <span className="akbar-check" style={{ color: akbarData.themeColor }}>✓</span>
                        150+ Branches Globally
                      </li>
                      <li className="akbar-list-item">
                        <span className="akbar-check" style={{ color: akbarData.themeColor }}>✓</span>
                        Specialized Umrah Packages
                      </li>
                      <li className="akbar-list-item">
                        <span className="akbar-check" style={{ color: akbarData.themeColor }}>✓</span>
                        5,000+ Holiday Packages
                      </li>
                      <li className="akbar-list-item">
                        <span className="akbar-check" style={{ color: akbarData.themeColor }}>✓</span>
                        Comprehensive Visa Services
                      </li>
                      <li className="akbar-list-item">
                        <span className="akbar-check" style={{ color: akbarData.themeColor }}>✓</span>
                        24/7 Multi-lingual Support
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'services' && (
            <section className="akbar-services">
              <div className="akbar-container">
                <h2 className="akbar-section-title akbar-text-center">
                  Comprehensive Travel Solutions
                </h2>
                <p className="akbar-section-subtitle">
                  Through our integration with Akbar Travels, we deliver end-to-end travel technology solutions
                </p>

                <div className="akbar-services-grid">
                  {services.map((service) => (
                    <div key={service.id} className="akbar-service-card">
                      <div className="akbar-service-icon">{service.icon}</div>
                      <h3 className="akbar-service-title">{service.title}</h3>
                      <p className="akbar-service-description">{service.description}</p>
                      <ul className="akbar-service-list">
                        {service.features.map((feature, index) => (
                          <li key={index} className="akbar-service-list-item">
                            <span className="akbar-dot" style={{ color: akbarData.themeColor }}>•</span>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          )}

          {activeTab === 'technology' && (
            <section className="akbar-technology">
              <div className="akbar-container">
                <div className="akbar-grid">
                  <div className="akbar-integration-box">
                    <h3 className="akbar-card-title">Seamless Integration</h3>
                    <p className="akbar-text">
                      Our integration with Akbar Travels' robust APIs ensures smooth data flow, real-time updates, and reliable performance. This technology partnership enables us to deliver exceptional travel services.
                    </p>
                    <div className="akbar-tags">
                      {technology.map((tech, index) => (
                        <span key={index} className="akbar-tag">{tech.title}</span>
                      ))}
                    </div>
                  </div>

                  <div className="akbar-benefits-box">
                    <h3 className="akbar-card-title">Key Advantages</h3>
                    <ul className="akbar-benefits-list">
                      <li className="akbar-benefits-item">
                        <span className="akbar-benefits-icon">⚡</span>
                        Lightning-fast API response times
                      </li>
                      <li className="akbar-benefits-item">
                        <span className="akbar-benefits-icon">🛡️</span>
                        Enterprise-grade security protocols
                      </li>
                      <li className="akbar-benefits-item">
                        <span className="akbar-benefits-icon">🎧</span>
                        Dedicated technical support
                      </li>
                      <li className="akbar-benefits-item">
                        <span className="akbar-benefits-icon">👥</span>
                        Experienced integration team
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'whyzotrai' && (
            <section className="akbar-why-zotrai-section">
              <div className="akbar-container">
                {/* Header */}
                <div className="akbar-why-header">
                  <span className="akbar-why-badge" style={{ background: `${companyInfo.themeColor}15`, color: companyInfo.themeColor }}>
                    <i className="ri-question-line"></i> WHY SUPPLIERS CHOOSE ZOTRAI
                  </span>
                  <h2 className="akbar-section-title">
                    Your Growth Partner in <span className="akbar-accent" style={{ color: companyInfo.themeColor }}>Travel Distribution</span>
                  </h2>
                  <p className="akbar-section-subtitle">
                    Join 50+ leading travel suppliers who trust us to connect them with travel agents
                  </p>
                </div>

                {/* Benefits Grid */}
                <div className="akbar-benefits-grid-full">
                  {whyZotraiData.benefits.map((benefit) => (
                    <div key={benefit.id} className="akbar-benefit-card">
                      <div className="akbar-benefit-icon-wrapper" style={{ background: `${companyInfo.themeColor}15` }}>
                        <i className={benefit.icon} style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="akbar-benefit-content">
                        <h3>{benefit.title}</h3>
                        <p>{benefit.description}</p>
                        <div className="akbar-benefit-stat">
                          <span className="akbar-stat-highlight" style={{ color: companyInfo.themeColor }}>{benefit.stat}</span>
                          <span className="akbar-stat-label">{benefit.statLabel}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Integration Process */}
                <div className="akbar-integration-process">
                  <h3 className="akbar-process-title">Simple 3-Step Integration</h3>
                  <div className="akbar-process-steps">
                    {whyZotraiData.process.map((step) => (
                      <div key={step.step} className="akbar-process-step">
                        <div className="akbar-step-number" style={{ background: companyInfo.themeColor }}>{step.step}</div>
                        <h4>{step.title}</h4>
                        <p>{step.description}</p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Contact Section */}
                <div className="akbar-contact-section">
                  <h3>Ready to Join Our Supplier Network?</h3>
                  <p>Connect with agents through a single integration</p>
                  
                  <div className="akbar-contact-info">
                    <div className="akbar-contact-item" onClick={handleEmailClick}>
                      <div className="akbar-contact-icon" style={{ backgroundColor: `${companyInfo.themeColor}15` }}>
                        <i className="ri-mail-line" style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="akbar-contact-details">
                        <span className="akbar-contact-label">Email Support</span>
                        <span className="akbar-contact-value">{companyInfo.email}</span>
                      </div>
                    </div>

                    <div className="akbar-contact-item" onClick={handlePhoneClick}>
                      <div className="akbar-contact-icon" style={{ backgroundColor: `${companyInfo.themeColor}15` }}>
                        <i className="ri-phone-line" style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="akbar-contact-details">
                        <span className="akbar-contact-label">Phone Support</span>
                        <span className="akbar-contact-value">{companyInfo.phone}</span>
                      </div>
                    </div>
                  </div>

                  <p className="akbar-contact-note">
                    Our support team is available 24/7 to assist you with any questions
                  </p>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'suppliers' && (
            <section className="akbar-suppliers-section">
              <div className="akbar-container">
                {/* Section Header */}
                <div className="akbar-suppliers-header">
                  <span className="akbar-suppliers-badge">
                    <i className="ri-handshake-line"></i> OUR INTEGRATED SUPPLIERS
                  </span>
                  <h2 className="akbar-section-title">
                    Connect With <span className="akbar-accent">Leading Travel Suppliers</span>
                  </h2>
                  <p className="akbar-section-subtitle">
                    Direct integrations with industry-leading travel suppliers worldwide
                  </p>
                </div>

                {/* Clickable Logo Grid */}
                <div className="akbar-logo-grid">
                  {suppliers.map((supplier) => (
                    <div 
                      key={supplier.id} 
                      className="akbar-logo-item akbar-clickable"
                      onClick={() => handleSupplierClick(supplier.path)}
                      role="button"
                      tabIndex={0}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          handleSupplierClick(supplier.path);
                        }
                      }}
                    >
                      <div className="akbar-logo-wrapper">
                        <img 
                          src={supplier.logo} 
                          alt={supplier.name}
                          className="akbar-supplier-logo"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `https://via.placeholder.com/80x40?text=${supplier.name.charAt(0)}`;
                          }}
                        />
                      </div>
                      <span className="akbar-logo-name">{supplier.name}</span>
                      <span className="akbar-view-details-hint">
                        View Details <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  ))}
                </div>

                {/* Simple Stats */}
                <div className="akbar-supplier-stats-simple">
                 
                  <div className="akbar-stat-simple">
                    <span className="akbar-stat-number">1M+</span>
                    <span className="akbar-stat-label">Hotel Properties</span>
                  </div>
                  <div className="akbar-stat-simple">
                    <span className="akbar-stat-number">80+</span>
                    <span className="akbar-stat-label">Airlines</span>
                  </div>
                  <div className="akbar-stat-simple">
                    <span className="akbar-stat-number">300K+</span>
                    <span className="akbar-stat-label">Activities</span>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'pricing' && (
            <section className="akbar-pricing-section">
              <div className="akbar-container">
                <div className="akbar-pricing-header">
                  <h2 className="akbar-section-title akbar-text-center">
                    Plans & <span className="akbar-accent">Pricing</span>
                  </h2>
                  <p className="akbar-section-subtitle">
                    Pick the plan that's right for your business growth
                  </p>
                  
                  {/* Billing Toggle */}
                  <div className="akbar-billing-toggle">
                    <button
                      className={`akbar-toggle-btn ${billingCycle === 1 ? 'akbar-toggle-active' : ''}`}
                      onClick={() => setBillingCycle(1)}
                    >
                      Monthly
                    </button>
                    <button
                      className={`akbar-toggle-btn ${billingCycle === 2 ? 'akbar-toggle-active' : ''}`}
                      onClick={() => setBillingCycle(2)}
                    >
                      Annually
                      <span className="akbar-save-badge">Save 20%</span>
                    </button>
                  </div>
                </div>

                {/* Pricing Cards */}
                <div className="akbar-pricing-grid">
                  {plans.map((plan) => {
                    const isMonthly = billingCycle === 1;
                    const accentColor = getAccentColor(plan.name);
                    
                    return (
                      <div key={plan.id} className="akbar-pricing-card-enhanced">
                        {plan.popular && (
                          <div className="akbar-popular-badge">
                            ⭐ MOST POPULAR
                          </div>
                        )}

                        <div className="akbar-pricing-card-content">
                          {/* Pricing Side */}
                          <div className="akbar-pricing-left" style={{ backgroundColor: plan.popular ? '#F4F9FF' : '#ffffff' }}>
                            <div className="akbar-pricing-emoji">{plan.emoji}</div>
                            <h3 className="akbar-pricing-name">{plan.name}</h3>
                            <p className="akbar-pricing-description">{plan.description}</p>

                            <div className="akbar-pricing-amount">
                              <span className="akbar-currency">INR</span>
                              <span className="akbar-price">
                                {isMonthly ? plan.monthly.toLocaleString() : plan.annually.toLocaleString()}
                              </span>
                              <span className="akbar-pricing-period">
                                /{isMonthly ? 'month' : 'year'}
                              </span>
                            </div>

                            <button 
                              className="akbar-pricing-cta"
                              style={{ backgroundColor: accentColor }}
                              onClick={() => window.location.href = '/signup'}
                            >
                              Start Free Trial <i className="ri-arrow-right-line"></i>
                            </button>

                            {/* Quick 3-Step Setup */}
                            <div className="akbar-quick-setup">
                              <h4 className="akbar-setup-title">Quick 3-Step Setup</h4>
                              <div className="akbar-setup-steps">
                                <div className="akbar-setup-step">
                                  <div className="akbar-step-marker" style={{ background: accentColor }}>1</div>
                                  <div className="akbar-step-content">
                                    <strong>Sign Up & Choose Plan</strong>
                                    <span>Create your account in 30 seconds - no credit card required</span>
                                  </div>
                                </div>
                                <div className="akbar-setup-step">
                                  <div className="akbar-step-marker" style={{ background: accentColor }}>2</div>
                                  <div className="akbar-step-content">
                                    <strong>Select Your Suppliers</strong>
                                    <span>Choose from leading travel suppliers with one click</span>
                                  </div>
                                </div>
                                <div className="akbar-setup-step">
                                  <div className="akbar-step-marker" style={{ background: accentColor }}>3</div>
                                  <div className="akbar-step-content">
                                    <strong>Launch Your Portal</strong>
                                    <span>Go live with your branded website in minutes</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Features Side */}
                          <div className="akbar-pricing-right">
                            <h5 className="akbar-features-title" style={{ color: accentColor }}>
                              Included in {plan.name}
                            </h5>
                            
                            <div className="akbar-features-list">
                              {plan.features.map((feature, index) => (
                                <div key={index} className="akbar-feature-item">
                                  <div className="akbar-feature-check" style={{ backgroundColor: `${accentColor}15` }}>
                                    <i className="ri-check-line" style={{ color: accentColor }}></i>
                                  </div>
                                  <span>{feature}</span>
                                </div>
                              ))}
                            </div>

                            <h5 className="akbar-features-title akbar-addons-title" style={{ color: accentColor }}>
                              Add-Ons
                            </h5>
                            
                            <div className="akbar-addons-list">
                              {plan.addons.map((addon, index) => (
                                <div key={index} className="akbar-addon-item">
                                  <div className="akbar-addon-check" style={{ backgroundColor: `${accentColor}15` }}>
                                    <i className="ri-add-line" style={{ color: accentColor }}></i>
                                  </div>
                                  <span>{addon}</span>
                                </div>
                              ))}
                            </div>

                            <div className="akbar-pricing-footer">
                              <span>✓ Transparent pricing, no hidden fees</span>
                              <span className="akbar-support-link" style={{ color: accentColor }}>
                                Need help? Chat with us
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </section>
          )}
        </div>
      </div>

      {/* Styles with akbar- prefix */}
      <style jsx>{`
        .akbar-supplier-container {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
          line-height: 1.6;
          color: #1e293b;
        }

        .akbar-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* Header Styles */
        .akbar-header {
          background: #ffffff;
          color: #1e293b;
          padding: 80px 0 40px;
          text-align: center;
        }

        .akbar-title {
          font-size: 3.5rem;
          font-weight: 800;
          margin: 0 0 15px;
          line-height: 1.2;
          color: #1e293b;
        }

        .akbar-highlight {
          font-size: 4rem;
          display: inline-block;
          font-weight: 800;
        }

        .akbar-subtitle {
          font-size: 1.25rem;
          max-width: 700px;
          margin: 0 auto;
          color: #475569;
        }

        /* Tabs Navigation */
        .akbar-tabs-container {
          background: #ffffff;
          border-bottom: 2px solid #e2e8f0;
          margin-bottom: 40px;
          position: sticky;
          top: 0;
          z-index: 100;
          backdrop-filter: blur(10px);
          background: rgba(255, 255, 255, 0.95);
        }

        .akbar-tabs {
          display: flex;
          gap: 30px;
          overflow-x: auto;
          padding: 0 24px;
        }

        .akbar-tab {
          background: none;
          border: none;
          padding: 16px 0;
          font-size: 1rem;
          font-weight: 600;
          color: #64748b;
          cursor: pointer;
          position: relative;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 8px;
          white-space: nowrap;
        }

        .akbar-tab:hover {
          color: #0f172a;
        }

        .akbar-tab-active {
          color: #0f172a;
        }

        .akbar-tab-active::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 3px;
          background: ${akbarData.themeColor};
        }

        .akbar-tab-badge {
          background: ${akbarData.themeColor};
          color: white;
          font-size: 0.7rem;
          padding: 2px 8px;
          border-radius: 12px;
          font-weight: 500;
        }

        /* About Section */
        .akbar-about {
          padding: 40px 0 60px;
          background: #ffffff;
        }

        .akbar-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 50px;
          align-items: start;
        }

        .akbar-section-title {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 24px;
          color: #0f172a;
        }

        .akbar-text-center {
          text-align: center;
        }

        .akbar-accent {
          position: relative;
          display: inline-block;
        }

        .akbar-accent::after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 100%;
          height: 4px;
          background: ${akbarData.themeColor};
          border-radius: 2px;
        }

        .akbar-text {
          font-size: 1.1rem;
          color: #475569;
          margin-bottom: 20px;
          line-height: 1.8;
        }

        .akbar-features {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
          margin-top: 30px;
        }

        .akbar-feature {
          display: flex;
          gap: 15px;
          padding: 20px;
          background: #f8fafc;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
          transition: all 0.3s ease;
        }

        .akbar-feature:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.05);
          border-color: ${akbarData.themeColor};
        }

        .akbar-feature-icon {
          font-size: 2rem;
          min-width: 50px;
        }

        .akbar-feature h4 {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 5px;
          color: #0f172a;
        }

        .akbar-feature p {
          font-size: 0.95rem;
          color: #475569;
          margin: 0;
        }

        .akbar-card {
          background: white;
          padding: 40px;
          border-radius: 24px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
          border: 1px solid #eef2f6;
        }

        .akbar-card-title {
          font-size: 1.5rem;
          font-weight: 600;
          margin-bottom: 24px;
          color: #0f172a;
        }

        .akbar-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .akbar-list-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
          font-size: 1rem;
          color: #334155;
        }

        .akbar-check {
          font-weight: bold;
          font-size: 1.2rem;
        }

        /* Services Section */
        .akbar-services {
          padding: 40px 0 60px;
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }

        .akbar-section-subtitle {
          font-size: 1.25rem;
          color: #475569;
          text-align: center;
          max-width: 700px;
          margin: 0 auto 50px;
        }

        .akbar-services-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }

        .akbar-service-card {
          background: white;
          padding: 35px 25px;
          border-radius: 20px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
          transition: all 0.3s ease;
          border: 1px solid #eef2f6;
          position: relative;
          overflow: hidden;
        }

        .akbar-service-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: ${akbarData.themeColor};
          transform: scaleX(0);
          transition: transform 0.3s ease;
        }

        .akbar-service-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px rgba(0, 168, 89, 0.1);
        }

        .akbar-service-card:hover::before {
          transform: scaleX(1);
        }

        .akbar-service-icon {
          font-size: 3rem;
          margin-bottom: 20px;
        }

        .akbar-service-title {
          font-size: 1.3rem;
          font-weight: 600;
          margin-bottom: 15px;
          color: #0f172a;
        }

        .akbar-service-description {
          color: #475569;
          margin-bottom: 20px;
          line-height: 1.6;
        }

        .akbar-service-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .akbar-service-list-item {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 10px;
          color: #475569;
          font-size: 0.95rem;
        }

        .akbar-dot {
          font-weight: bold;
        }

        /* Technology Section */
        .akbar-technology {
          padding: 40px 0 60px;
          background: white;
        }

        .akbar-integration-box,
        .akbar-benefits-box {
          background: linear-gradient(135deg, #f8fafc, #f1f5f9);
          padding: 40px;
          border-radius: 24px;
          border: 1px solid #eef2f6;
        }

        .akbar-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-top: 25px;
        }

        .akbar-tag {
          background: white;
          padding: 8px 16px;
          border-radius: 30px;
          font-size: 0.9rem;
          color: ${akbarData.themeColor};
          font-weight: 500;
          border: 1px solid ${akbarData.themeColor}30;
          transition: all 0.3s ease;
        }

        .akbar-tag:hover {
          background: ${akbarData.themeColor};
          color: white;
          border-color: ${akbarData.themeColor};
          transform: scale(1.05);
        }

        .akbar-benefits-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .akbar-benefits-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
          font-size: 1.1rem;
          color: #1e293b;
        }

        .akbar-benefits-icon {
          font-size: 1.5rem;
          background: white;
          width: 45px;
          height: 45px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 12px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.05);
        }

        /* Why Zotrai Section */
        .akbar-why-zotrai-section {
          padding: 40px 0 80px;
          background: #ffffff;
        }

        .akbar-why-header {
          text-align: center;
          margin-bottom: 50px;
        }

        .akbar-why-badge {
          display: inline-block;
          padding: 8px 20px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.9rem;
          margin-bottom: 20px;
        }

        .akbar-benefits-grid-full {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 25px;
          margin-bottom: 50px;
        }

        .akbar-benefit-card {
          display: flex;
          gap: 20px;
          background: #f8fafc;
          padding: 25px;
          border-radius: 20px;
          border: 1px solid #eef2f6;
          transition: all 0.3s ease;
        }

        .akbar-benefit-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.05);
          border-color: ${companyInfo.themeColor};
        }

        .akbar-benefit-icon-wrapper {
          width: 60px;
          height: 60px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .akbar-benefit-icon-wrapper i {
          font-size: 2rem;
        }

        .akbar-benefit-content h3 {
          font-size: 1.2rem;
          font-weight: 600;
          margin-bottom: 8px;
          color: #0f172a;
        }

        .akbar-benefit-content p {
          color: #475569;
          font-size: 0.95rem;
          margin-bottom: 12px;
          line-height: 1.6;
        }

        .akbar-benefit-stat {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .akbar-stat-highlight {
          font-size: 1.2rem;
          font-weight: 700;
        }

        .akbar-integration-process {
          text-align: center;
          margin: 60px 0;
        }

        .akbar-process-title {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 40px;
          color: #0f172a;
        }

        .akbar-process-steps {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }

        .akbar-process-step {
          text-align: center;
          padding: 30px;
          background: #f8fafc;
          border-radius: 20px;
          border: 1px solid #eef2f6;
        }

        .akbar-process-step .akbar-step-number {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          font-weight: 700;
          margin: 0 auto 20px;
        }

        /* Contact Section */
        .akbar-contact-section {
          background: #ffffff;
          padding: 60px;
          border-radius: 30px;
          text-align: center;
          color: #0f172a;
          margin-top: 60px;
          border: 2px solid #eef2f6;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
        }

        .akbar-contact-section h3 {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 15px;
          color: #0f172a;
        }

        .akbar-contact-section p {
          font-size: 1.2rem;
          color: #475569;
          margin-bottom: 40px;
        }

        .akbar-contact-info {
          display: flex;
          justify-content: center;
          gap: 30px;
          margin-bottom: 30px;
          flex-wrap: wrap;
        }

        .akbar-contact-item {
          display: flex;
          align-items: center;
          gap: 15px;
          padding: 20px 30px;
          background: #f8fafc;
          border-radius: 16px;
          border: 1px solid #eef2f6;
          cursor: pointer;
          transition: all 0.3s ease;
          min-width: 280px;
        }

        .akbar-contact-item:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
          border-color: ${companyInfo.themeColor};
        }

        .akbar-contact-icon {
          width: 50px;
          height: 50px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .akbar-contact-icon i {
          font-size: 1.8rem;
        }

        .akbar-contact-details {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .akbar-contact-label {
          font-size: 0.85rem;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .akbar-contact-value {
          font-size: 1.2rem;
          font-weight: 600;
          color: #0f172a;
        }

        .akbar-contact-note {
          font-size: 0.95rem !important;
          color: #64748b !important;
          margin-top: 20px;
          margin-bottom: 0 !important;
        }

        /* Suppliers Section */
        .akbar-suppliers-section {
          padding: 40px 0 80px;
          background: #ffffff;
        }

        .akbar-suppliers-header {
          text-align: center;
          margin-bottom: 50px;
        }

        .akbar-suppliers-badge {
          display: inline-block;
          background: linear-gradient(135deg, #2563eb15, #7c3aed15);
          color: #2563eb;
          padding: 8px 20px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.9rem;
          margin-bottom: 20px;
          border: 1px solid #2563eb20;
        }

        .akbar-suppliers-badge i {
          margin-right: 8px;
        }

        .akbar-logo-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 30px;
          margin-bottom: 50px;
        }

        .akbar-logo-item {
          text-align: center;
          padding: 20px;
          background: white;
          border-radius: 16px;
          border: 1px solid #eef2f6;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .akbar-logo-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(37, 99, 235, 0.15);
          border-color: #2563eb;
        }

        .akbar-logo-item:hover .akbar-view-details-hint {
          opacity: 1;
          transform: translateY(0);
        }

        .akbar-logo-wrapper {
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 15px;
        }

        .akbar-supplier-logo {
          max-width: 120px;
          max-height: 60px;
          object-fit: contain;
          transition: transform 0.3s ease;
        }

        .akbar-logo-item:hover .akbar-supplier-logo {
          transform: scale(1.05);
        }

        .akbar-logo-name {
          font-size: 0.95rem;
          font-weight: 600;
          color: #1e293b;
          display: block;
          margin-bottom: 5px;
        }

        .akbar-view-details-hint {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 0.8rem;
          color: #2563eb;
          font-weight: 500;
          opacity: 0;
          transform: translateY(10px);
          transition: all 0.3s ease;
        }

        .akbar-supplier-stats-simple {
          display: flex;
          justify-content: space-around;
          align-items: center;
          background: linear-gradient(135deg, #f8fafc, #ffffff);
          padding: 30px;
          border-radius: 20px;
          border: 1px solid #eef2f6;
          flex-wrap: wrap;
          gap: 20px;
        }

        .akbar-stat-simple {
          text-align: center;
        }

        .akbar-stat-simple .akbar-stat-number {
          display: block;
          font-size: 2rem;
          font-weight: 800;
          color: #2563eb;
          line-height: 1.2;
        }

        .akbar-stat-simple .akbar-stat-label {
          font-size: 0.9rem;
          color: #64748b;
        }

        /* Pricing Section */
        .akbar-pricing-section {
          padding: 40px 0 80px;
          background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        }

        .akbar-pricing-header {
          text-align: center;
          margin-bottom: 40px;
        }

        .akbar-billing-toggle {
          display: inline-flex;
          background: white;
          padding: 4px;
          border-radius: 50px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          margin-top: 20px;
        }

        .akbar-toggle-btn {
          border: none;
          padding: 12px 32px;
          font-size: 1rem;
          font-weight: 600;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s ease;
          background: transparent;
          color: #64748b;
          position: relative;
        }

        .akbar-toggle-active {
          background: #2563eb;
          color: white;
        }

        .akbar-save-badge {
          background: #fbbf24;
          color: #1e293b;
          font-size: 0.7rem;
          padding: 2px 8px;
          border-radius: 12px;
          margin-left: 8px;
          font-weight: 500;
        }

        .akbar-pricing-grid {
          max-width: 1000px;
          margin: 0 auto;
        }

        .akbar-pricing-card-enhanced {
          background: white;
          border-radius: 24px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
          border: 1px solid #eef2f6;
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .akbar-pricing-card-enhanced:hover {
          transform: translateY(-5px);
          box-shadow: 0 30px 60px rgba(37, 99, 235, 0.12);
        }

        .akbar-popular-badge {
          position: absolute;
          top: 20px;
          right: 30px;
          background: #2563eb;
          color: white;
          padding: 8px 16px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.85rem;
          z-index: 10;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
        }

        .akbar-pricing-card-content {
          display: grid;
          grid-template-columns: 1fr 1.2fr;
        }

        .akbar-pricing-left {
          padding: 40px;
          border-right: 1px solid #eef2f6;
        }

        .akbar-pricing-emoji {
          font-size: 2.5rem;
          margin-bottom: 15px;
        }

        .akbar-pricing-name {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 10px;
          color: #0f172a;
        }

        .akbar-pricing-description {
          color: #475569;
          font-size: 0.95rem;
          margin-bottom: 25px;
        }

        .akbar-pricing-amount {
          margin-bottom: 25px;
        }

        .akbar-currency {
          font-size: 1.2rem;
          font-weight: 600;
          color: #64748b;
          margin-right: 5px;
        }

        .akbar-price {
          font-size: 3.5rem;
          font-weight: 800;
          color: #0f172a;
          line-height: 1;
        }

        .akbar-pricing-period {
          font-size: 1rem;
          color: #64748b;
          margin-left: 5px;
        }

        .akbar-pricing-cta {
          width: 100%;
          border: none;
          padding: 16px;
          border-radius: 12px;
          color: white;
          font-weight: 600;
          font-size: 1.1rem;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-bottom: 30px;
        }

        .akbar-pricing-cta:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1);
        }

        .akbar-quick-setup {
          background: #f8fafc;
          border-radius: 16px;
          padding: 20px;
        }

        .akbar-setup-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 20px;
          color: #0f172a;
        }

        .akbar-setup-steps {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .akbar-setup-step {
          display: flex;
          gap: 12px;
          align-items: flex-start;
        }

        .akbar-step-marker {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          font-size: 0.9rem;
          flex-shrink: 0;
        }

        .akbar-step-content {
          display: flex;
          flex-direction: column;
        }

        .akbar-step-content strong {
          font-size: 0.95rem;
          margin-bottom: 4px;
        }

        .akbar-step-content span {
          font-size: 0.85rem;
          color: #64748b;
        }

        .akbar-pricing-right {
          padding: 40px;
          background: #ffffff;
        }

        .akbar-features-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 20px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .akbar-addons-title {
          margin-top: 30px;
        }

        .akbar-features-list,
        .akbar-addons-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .akbar-feature-item,
        .akbar-addon-item {
          display: flex;
          gap: 12px;
          align-items: flex-start;
        }

        .akbar-feature-check,
        .akbar-addon-check {
          width: 22px;
          height: 22px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-top: 2px;
        }

        .akbar-feature-check i,
        .akbar-addon-check i {
          font-size: 14px;
        }

        .akbar-feature-item span,
        .akbar-addon-item span {
          font-size: 0.95rem;
          color: #334155;
          line-height: 1.5;
        }

        .akbar-pricing-footer {
          margin-top: 30px;
          padding-top: 20px;
          border-top: 1px solid #e2e8f0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.9rem;
        }

        .akbar-support-link {
          cursor: pointer;
          font-weight: 500;
        }

        .akbar-support-link:hover {
          text-decoration: underline;
        }

        /* Accessibility */
        .akbar-clickable:focus-visible {
          outline: 3px solid #2563eb;
          outline-offset: 2px;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .akbar-grid {
            grid-template-columns: 1fr;
            gap: 30px;
          }
          
          .akbar-services-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .akbar-benefits-grid-full {
            grid-template-columns: 1fr;
          }

          .akbar-process-steps {
            grid-template-columns: 1fr;
          }

          .akbar-logo-grid {
            grid-template-columns: repeat(3, 1fr);
          }

          .akbar-pricing-card-content {
            grid-template-columns: 1fr;
          }

          .akbar-pricing-left {
            border-right: none;
            border-bottom: 1px solid #eef2f6;
          }

          .akbar-contact-info {
            flex-direction: column;
            align-items: center;
          }

          .akbar-contact-item {
            width: 100%;
            max-width: 400px;
          }
        }

        @media (max-width: 768px) {
          .akbar-title {
            font-size: 2.5rem;
          }
          
          .akbar-highlight {
            font-size: 3rem;
          }
          
          .akbar-tabs {
            gap: 20px;
            overflow-x: auto;
            padding-bottom: 5px;
          }
          
          .akbar-tab {
            font-size: 0.95rem;
            white-space: nowrap;
          }
          
          .akbar-services-grid {
            grid-template-columns: 1fr;
          }
          
          .akbar-section-title {
            font-size: 2rem;
          }

          .akbar-features {
            grid-template-columns: 1fr;
          }

          .akbar-logo-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .akbar-supplier-stats-simple {
            flex-direction: column;
            gap: 20px;
          }

          .akbar-contact-section {
            padding: 40px 20px;
          }

          .akbar-contact-section h3 {
            font-size: 1.8rem;
          }

          .akbar-contact-item {
            padding: 15px 20px;
          }

          .akbar-contact-value {
            font-size: 1rem;
          }
        }

        @media (max-width: 480px) {
          .akbar-header {
            padding: 60px 0 30px;
          }

          .akbar-logo-grid {
            grid-template-columns: 1fr;
          }

          .akbar-pricing-left,
          .akbar-pricing-right {
            padding: 25px;
          }

          .akbar-price {
            font-size: 2.5rem;
          }

          .akbar-billing-toggle {
            flex-direction: column;
            width: 100%;
            border-radius: 12px;
          }

          .akbar-toggle-btn {
            width: 100%;
          }

          .akbar-contact-item {
            flex-direction: column;
            text-align: center;
          }

          .akbar-contact-details {
            align-items: center;
          }
        }
      `}</style>
    </>
  );
};

// Simple Helmet component for meta tags
const Helmet = ({ children }) => {
  return <>{children}</>;
};

export default AkbarTravelsSupplierHighlight;